import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
const COMMENT_TOO_LONG_PATTERN = /comment message is too long/i;
export function isCommentTooLongError(error) {
  var _err$responseJSON;
  if (!error || typeof error !== 'object') {
    return false;
  }
  const err = error;
  if (typeof ((_err$responseJSON = err.responseJSON) === null || _err$responseJSON === void 0 ? void 0 : _err$responseJSON.message) === 'string' && COMMENT_TOO_LONG_PATTERN.test(err.responseJSON.message)) {
    return true;
  }
  if (typeof err.data === 'string' && COMMENT_TOO_LONG_PATTERN.test(err.data)) {
    return true;
  }
  if (typeof err.message === 'string' && COMMENT_TOO_LONG_PATTERN.test(err.message)) {
    return true;
  }
  return false;
}
function getPasteShortcut() {
  return navigator.userAgent.includes('Mac') ? '⌘+Shift+V' : 'Ctrl+Shift+V';
}
export function showCommentTooLongAlert() {
  FloatingAlertStore.addAlert({
    type: 'danger',
    titleText: I18n.text('objectCommentsThread.comments.alerts.commentTooLongError'),
    message: I18n.text('objectCommentsThread.comments.alerts.commentTooLongPasteHint', {
      shortcut: getPasteShortcut()
    })
  });
}